//
//
//
//
//
//
//
//

import toggleRule from './_togglr_rule'
export default {
    props: {
        count: Number
    },
    name: 'CommentHeader',
    components: {
        toggleRule
    },
}
